var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tree-select-input',{ref:"searchTreeSelectInput",attrs:{"data-list":_vm.categoryList,"value":_vm.innerValue,"beforeOnSelect":_vm.beforeOnSelect,"disabled":_vm.disabled},on:{"select-node":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }